<template>
  <div  :style="{'width': '1880px', height: (height - 82) + 'px'}" style="margin: 0 auto" >
    <div class="diagram sub-left" style="margin: 0 auto;width: 100%;position: relative">
      <div style="z-index: 998;position: absolute;left: 1rem;top: 3rem" class="table-size">
        <div class="main-table D01" style="height: 7.98rem">
          <div class="JL">
            <div class="main-table-row IA"  >
              <span class="main-table-cell" style="flex: auto">4ES环境参数（1）</span>
            </div>
            <div class="main-table-row IB" >
              <span class="main-table-cell">温度</span>
              <span class="main-table-cell" style="flex: auto" >{{sensorCompute('ES4T02', 0)}}</span>
            </div>
            <div class="main-table-row P" >
              <span class="main-table-cell">湿度</span>
              <span class="main-table-cell uc-value" style="flex: auto" >{{ sensorCompute('ES4T02', 1)}}</span>
            </div>
            <div class="main-table-row COS">
              <span class="main-table-cell">烟雾</span>
              <span class="main-table-cell uc-value" style="flex: auto" >{{sensorCompute('ES4Y02', 2)}}</span>
            </div>
            <div class="main-table-row Q">
              <span class="main-table-cell">水浸</span>
              <span class="main-table-cell uc-value" style="flex: auto">{{sensorCompute('ES4S02', 3)}}</span>
            </div>
          </div>
        </div>
      </div>
      <div style="z-index: 998;position: absolute;left: 12rem;top: 3rem" class="table-size">
        <div class="main-table D01" style="height: 7.98rem">
          <div class="JL">
            <div class="main-table-row IA"  >
              <span class="main-table-cell" style="flex: auto">4ES环境参数（2）</span>
            </div>
            <div class="main-table-row IB" >
              <span class="main-table-cell">温度</span>
              <span class="main-table-cell" style="flex: auto" >{{sensorCompute('ES4T01', 0)}}</span>
            </div>
            <div class="main-table-row P" >
              <span class="main-table-cell">湿度</span>
              <span class="main-table-cell uc-value" style="flex: auto" >{{sensorCompute('ES4T01', 1)}}</span>
            </div>
            <div class="main-table-row COS">
              <span class="main-table-cell">烟雾</span>
              <span class="main-table-cell uc-value" style="flex: auto" >{{sensorCompute('ES4Y01', 2)}}</span>
            </div>
            <div class="main-table-row Q">
              <span class="main-table-cell">水浸</span>
              <span class="main-table-cell uc-value" style="flex: auto">{{sensorCompute('ES4S01', 3)}}</span>
            </div>
          </div>
        </div>
      </div>

      <div style="z-index: 998;position: absolute;left: 29.6rem;top: 2.6rem;" class="table-size" v-if="false">
        <div class="main-table D01">
          <div class="JL">
            <div class="main-table-row IA" >
              <span class="main-table-cell">I</span>
              <span class="main-table-cell" ng-bind="ia8111 || '45.70A'"></span>
            </div>
            <div class="main-table-row IB" >
              <span class="main-table-cell">U</span>
              <span class="main-table-cell" ng-bind="ua8111 || '5989.7V'"></span>
            </div>
            <div class="main-table-row P" >
              <span class="main-table-cell">P</span>
              <span class="main-table-cell uc-value" ng-bind="p8111 || '450kW'"></span>
            </div>
            <div class="main-table-row COS">
              <span class="main-table-cell">cos</span>
              <span class="main-table-cell uc-value" ng-bind="pf8111 || '0.95'"></span>
            </div>
          </div>
        </div>
      </div>
      <div style="z-index: 998;position: absolute;left: 46.5rem;top: 2.6rem" class="table-size" v-if="false">
        <div class="main-table D01">
          <div class="JL">
            <div class="main-table-row IA" >
              <span class="main-table-cell">I</span>
              <span class="main-table-cell" ng-bind="ia8111 || '21.8A'"></span>
            </div>
            <div class="main-table-row IB" >
              <span class="main-table-cell">U</span>
              <span class="main-table-cell" ng-bind="ua8111 || '5961.1V'"></span>
            </div>
            <div class="main-table-row P" >
              <span class="main-table-cell">P</span>
              <span class="main-table-cell uc-value" ng-bind="p8111 || '216.2kW'"></span>
            </div>
            <div class="main-table-row COS">
              <span class="main-table-cell">cos</span>
              <span class="main-table-cell uc-value" ng-bind="pf8111 || '0.96'"></span>
            </div>
          </div>
        </div>
      </div>
      <div style="z-index: 998;position: absolute;left: 76rem;top: 2.6rem" class="table-size" v-if="false">
        <div class="main-table D01">
          <div class="JL">
            <div class="main-table-row IA" >
              <span class="main-table-cell">I</span>
              <span class="main-table-cell" ng-bind="ia8111 || '4.3A'"></span>
            </div>
            <div class="main-table-row IB" >
              <span class="main-table-cell">U</span>
              <span class="main-table-cell" ng-bind="ua8111 || '5992.1V'"></span>
            </div>
            <div class="main-table-row P" >
              <span class="main-table-cell">P</span>
              <span class="main-table-cell uc-value" ng-bind="p8111 || '43.2kW'"></span>
            </div>
            <div class="main-table-row COS">
              <span class="main-table-cell">cos</span>
              <span class="main-table-cell uc-value" ng-bind="pf8111 || '0.97'"></span>
            </div>
          </div>
        </div>
      </div>
      <div style="z-index: 998;position: absolute;left: 92.5rem;top: 2.6rem" class="table-size" v-if="false">
        <div class="main-table D01">
          <div class="JL">
            <div class="main-table-row IA" >
              <span class="main-table-cell">I</span>
              <span class="main-table-cell" ng-bind="ia8111 || '4.50A'"></span>
            </div>
            <div class="main-table-row IB" >
              <span class="main-table-cell">U</span>
              <span class="main-table-cell" ng-bind="ua8111 || '5923.6V'"></span>
            </div>
            <div class="main-table-row P" >
              <span class="main-table-cell">P</span>
              <span class="main-table-cell uc-value" ng-bind="p8111 || '44.3kW'"></span>
            </div>
            <div class="main-table-row COS">
              <span class="main-table-cell">cos</span>
              <span class="main-table-cell uc-value" ng-bind="pf8111 || '0.95'"></span>
            </div>
          </div>
        </div>
      </div>


      <img src="../../assets/img/es4.svg"   alt="ES4背景图" class="bg-diagram" draggable="false" style="height: auto;position: absolute;left: 0;top: 0">
      <div >
        <SignalNode node-title="D4-2AN14" type="1" remark="4" info="柴发进线柜"  :context="context" node-style="position: absolute;width: 5.8rem;height: auto;left: 29.0rem;top: 38.8rem;background-color: transparent;"></SignalNode>

        <SignalNode node-title="J411" info="411进线隔离小车" :context="context" node-style="left: 28.23rem;top: 3.0625rem;background-color: #FF2929;" class="off"></SignalNode>
        <SignalNode :context="context" info="4-#2变压器412开关小车" node-title="J412" node-style="left: 44.91rem;top: 3.0625rem;background-color: #FF2929;" class="off"></SignalNode>
        <SignalNode :context="context" info="351进线隔离小车" node-title="J351" node-style="left: 73.54rem;top: 3.0625rem;background-color: #FF2929;" class="off"></SignalNode>
        <SignalNode :context="context" info="4-#1变压器352开关小车" node-title="J352" node-style="left: 90.21rem;top: 3.0625rem;background-color: #FF2929;" class="off"></SignalNode>

        <SignalNode :context="context" info="消防电源箱（备用）" node-title="D4-1AN12-1" node-style="left: 2.2rem;top: 17.2rem;"></SignalNode>
        <SignalNode :context="context" info="消防风机（主用）" node-title="D4-1AN12-2" node-style="left: 5.09rem;top: 17.2rem;"></SignalNode>
        <SignalNode :context="context" info="消防水泵房（主用）" node-title="D4-1AN12-3" node-style="left: 7.97rem;top: 17.2rem;"></SignalNode>
        <SignalNode :context="context" info="消防水泵房（主用）" node-title="D4-1AN12-4" node-style="left: 10.9rem;top: 17.2rem;"></SignalNode>
        <SignalNode :context="context" info="消防风机（主用）" node-title="D4-1AN12-5" node-style="left: 13.79rem;top: 17.2rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（主用）" node-title="D4-1AN12-6" node-style="left: 16.65rem;top: 17.2rem;"></SignalNode>
        <SignalNode :context="context" info="人防平时用电总箱（备用）" node-title="D4-1AN12-7" node-style="left: 19.54rem;top: 17.2rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-1AN12-8" node-style="left: 22.46rem;top: 17.2rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-1AN12-9" node-style="left: 25.3rem;top: 17.2rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-1AN12-10" node-style="left: 28.22rem;top: 17.2rem;"></SignalNode>

        <SignalNode :context="context" info="消防控制室（主用）" node-title="D4-1AN11-1" node-style="left: 32.45rem;top: 17.15rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（备用）" node-title="D4-1AN11-2" node-style="left: 35.23rem;top: 17.15rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（备用）" node-title="D4-1AN11-3" node-style="left: 38.04rem;top: 17.15rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源（主用）" node-title="D4-1AN11-4" node-style="left: 40.84rem;top: 17.15rem;"></SignalNode>
        <SignalNode :context="context" info="消防风机（备用）" node-title="D4-1AN11-5" node-style="left: 43.6rem;top: 17.15rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-1AN11-6" node-style="left: 46.4rem;top: 17.15rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-1AN11-7" node-style="left: 49.2rem;top: 17.15rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-1AN11-8" node-style="left: 51.95rem;top: 17.15rem;"></SignalNode>


        <SignalNode :context="context" info="指挥中心电源箱（备用）" node-title="D4-1AN10-1" node-style="left: 56.219rem;top: 17.18rem;"></SignalNode>
        <SignalNode :context="context" info="室外活动预留配电箱" node-title="D4-1AN10-2" node-style="left: 59.16rem;top: 17.18rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-1AN10-3" node-style="left: 62.07rem;top: 17.18rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-1AN10-4" node-style="left: 64.97rem;top: 17.18rem;"></SignalNode>
        <SignalNode :context="context" info="UPS（主用）" node-title="D4-1AN10-5" node-style="left: 67.9rem;top: 17.18rem;"></SignalNode>
        <SignalNode :context="context" info="UPS（备用）" node-title="D4-1AN10-6" node-style="left: 70.8rem;top: 17.18rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-1AN10-7" node-style="left: 73.72rem;top: 17.18rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-1AN10-8" node-style="left: 76.65rem;top: 17.18rem;"></SignalNode>


        <SignalNode :context="context" info="电信（备用）" node-title="D4-1AN9-1" node-style="left: 80.79rem;top: 17.18rem;"></SignalNode>
        <SignalNode :context="context" info="人防电站" node-title="D4-1AN9-2" node-style="left: 83.595rem;top: 17.18rem;"></SignalNode>
        <SignalNode :context="context" info="商业" node-title="D4-1AN9-3" node-style="left: 86.35rem;top: 17.18rem;"></SignalNode>
        <SignalNode :context="context" info="商业" node-title="D4-1AN9-4" node-style="left: 89.15rem;top: 17.18rem;"></SignalNode>
        <SignalNode :context="context" info="商业" node-title="D4-1AN9-5" node-style="left: 91.91rem;top: 17.18rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-1AN9-6" node-style="left: 94.7rem;top: 17.18rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-1AN9-7" node-style="left: 97.46rem;top: 17.18rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-1AN9-8" node-style="left: 100.26rem;top: 17.18rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-1AN9-9" node-style="left: 103.04rem;top: 17.18rem;"></SignalNode>


        <SignalNode :context="context" info="避难走道照明水泵（备用）" node-title="D4-1AN8-1" node-style="left: 107.04rem;top: 17.18rem;"></SignalNode>
        <SignalNode :context="context" info="商业" node-title="D4-1AN8-2" node-style="left: 109.6rem;top: 17.18rem;"></SignalNode>
        <SignalNode :context="context" info="避难走道用电" node-title="D4-1AN8-3" node-style="left: 112.16rem;top: 17.18rem;"></SignalNode>

        <SignalNode :context="context" info="商业" node-title="D4-1AN8-4" node-style="left: 2.12rem;top: 29.29rem;"></SignalNode>
        <SignalNode :context="context" info="弱电进线间（备用）" node-title="D4-1AN8-5" node-style="left: 5.04rem;top: 29.29rem;"></SignalNode>
        <SignalNode :context="context" info="人防战时用电总箱" node-title="D4-1AN8-6" node-style="left: 7.96rem;top: 29.29rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-1AN8-7" node-style="left: 10.85rem;top: 29.29rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-1AN8-8" node-style="left: 13.75rem;top: 29.29rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-1AN8-9" node-style="left: 16.66rem;top: 29.29rem;"></SignalNode>


        <SignalNode :context="context" info="转播设备（主用）" node-title="D4-1AN7-1" node-style="left: 22.2rem;top: 29.29rem;"></SignalNode>
        <SignalNode :context="context" info="商业" node-title="D4-1AN7-2" node-style="left: 24.85rem;top: 29.29rem;"></SignalNode>
        <SignalNode :context="context" info="走道照明" node-title="D4-1AN7-3" node-style="left: 27.47rem;top: 29.29rem;"></SignalNode>
        <SignalNode :context="context" info="潜污泵" node-title="D4-1AN7-4" node-style="left: 30.08rem;top: 29.29rem;"></SignalNode>
        <SignalNode :context="context" info="照明总箱1" node-title="D4-1AN7-5" node-style="left: 32.71rem;top: 29.29rem;"></SignalNode>
        <SignalNode :context="context" info="站用电（主用）" node-title="D4-1AN7-6" node-style="left: 35.35rem;top: 29.29rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-1AN7-7" node-style="left: 38rem;top: 29.29rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-1AN7-8" node-style="left: 40.6rem;top: 29.29rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-1AN7-9" node-style="left: 43.28rem;top: 29.29rem;"></SignalNode>

        <SignalNode :context="context" info="照明总箱（主用）" node-title="D4-1AN6-1" node-style="left: 50.66rem;top: 29.23rem;"></SignalNode>
        <SignalNode :context="context" info="普通风机总箱" node-title="D4-1AN6-2" node-style="left: 53.34rem;top: 29.23rem;"></SignalNode>
        <SignalNode :context="context" info="商业" node-title="D4-1AN6-3" node-style="left: 56.04rem;top: 29.23rem;"></SignalNode>
        <SignalNode :context="context" info="空调风机总箱" node-title="D4-1AN6-4" node-style="left: 58.72rem;top: 29.23rem;"></SignalNode>
        <SignalNode :context="context" info="UPS（备用）" node-title="D4-1AN6-5" node-style="left: 61.4rem;top: 29.23rem;"></SignalNode>
        <SignalNode :context="context" info="信息网络机房（主用）" node-title="D4-1AN6-6" node-style="left: 64.04rem;top: 29.23rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-1AN6-7" node-style="left: 66.71rem;top: 29.23rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-1AN6-8" node-style="left: 69.38rem;top: 29.23rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-1AN6-9" node-style="left: 72.04rem;top: 29.23rem;"></SignalNode>

        <SignalNode :context="context" info="泛光照明配电箱" node-title="D4-1AN5-1" node-style="left: 76.78rem;top: 29.23rem;"></SignalNode>
        <SignalNode :context="context" info="场地照明（主用）" node-title="D4-1AN5-2" node-style="left: 79.35rem;top: 29.23rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-1AN5-3" node-style="left: 81.94rem;top: 29.23rem;"></SignalNode>
        <SignalNode :context="context" info="草坪补光系统" node-title="D4-1AN5-4" node-style="left: 84.53rem;top: 29.23rem;"></SignalNode>
        <SignalNode :context="context" info="安全照明（主用）" node-title="D4-1AN5-5" node-style="left: 87.13rem;top: 29.23rem;"></SignalNode>
        <SignalNode :context="context" info="端屏（备用）" node-title="D4-1AN5-6" node-style="left: 89.71rem;top: 29.23rem;"></SignalNode>
        <SignalNode :context="context" info="场地照明（主用）" node-title="D4-1AN5-7" node-style="left: 92.29rem;top: 29.23rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-1AN5-8" node-style="left: 94.85rem;top: 29.23rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-1AN5-9" node-style="left: 97.41rem;top: 29.23rem;"></SignalNode>

        <SignalNode :context="context" info="有源滤波装置" node-title="D4-1AN4" node-style="left: 101.91rem;top: 29.23rem;"></SignalNode>

        <SignalNode :context="context" info="动态自动无功补偿" node-title="D4-1AN3" node-style="left: 106.6rem;top: 29.23rem;"></SignalNode>

        <SignalNode :context="context" info="动态自动无功补偿" node-title="D4-1AN2" node-style="left: 111.48rem;top: 29.23rem;"></SignalNode>

        <SignalNode :context="context" info="4-#1变压器进线柜" node-title="D4-1AN1" node-style="left: 114.35rem;top: 29.23rem;"></SignalNode>



        <SignalNode :context="context" info="备用" node-title="D4-2AN16-1" node-style="left: 2.16rem;top: 42.1rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN16-2" node-style="left: 4.39rem;top: 42.1rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN16-3" node-style="left: 6.6rem;top: 42.1rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN16-4" node-style="left: 8.8rem;top: 42.1rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN16-5" node-style="left: 11.0rem;top: 42.1rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN16-6" node-style="left: 13.25rem;top: 42.1rem;"></SignalNode>

        <SignalNode :context="context" info="场地照明（主用）" node-title="D4-2AN15-1" node-style="left: 15.5rem;top: 42.1rem;"></SignalNode>
        <SignalNode :context="context" info="场地照明（备用）" node-title="D4-2AN15-2" node-style="left: 17.73rem;top: 42.1rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN15-3" node-style="left: 19.95rem;top: 42.1rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN15-4" node-style="left: 22.15rem;top: 42.1rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN15-5" node-style="left: 24.38rem;top: 42.1rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN15-6" node-style="left: 26.6rem;top: 42.1rem;"></SignalNode>


        <SignalNode :context="context" info="消防风机（主用）" node-title="D4-2AN13-1" node-style="left: 35.4rem;top: 42.1rem;"></SignalNode>
        <SignalNode :context="context" info="消防水泵房（备用）" node-title="D4-2AN13-2" node-style="left: 37.7rem;top: 42.1rem;"></SignalNode>
        <SignalNode :context="context" info="消防水泵房（备用）" node-title="D4-2AN13-3" node-style="left: 40.05rem;top: 42.1rem;"></SignalNode>
        <SignalNode :context="context" info="消防风机（备用）" node-title="D4-2AN13-4" node-style="left: 42.4rem;top: 42.1rem;"></SignalNode>
        <SignalNode :context="context" info="消防风机（备用）" node-title="D4-2AN13-5" node-style="left: 44.75rem;top: 42.1rem;"></SignalNode>
        <SignalNode :context="context" info="人防平时用电总箱（消防备用）" node-title="D4-2AN13-6" node-style="left: 47.05rem;top: 42.1rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN13-7" node-style="left: 49.41rem;top: 42.1rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN13-8" node-style="left: 51.79rem;top: 42.1rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN13-9" node-style="left: 54.15rem;top: 42.1rem;"></SignalNode>

        <SignalNode :context="context" info="母联柜" node-title="D4-2AN12" node-style="left: 58.04rem;top: 42.16rem;"></SignalNode>

        <SignalNode :context="context" info="消防电源箱（主用）" node-title="D4-2AN11-1" node-style="left: 61.54rem;top: 42.0rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（主用）" node-title="D4-2AN11-2" node-style="left: 63.58rem;top: 42.0rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源（备用）" node-title="D4-2AN11-3" node-style="left: 65.55rem;top: 42.0rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（主用）" node-title="D4-2AN11-4" node-style="left: 67.6rem;top: 42.0rem;"></SignalNode>
        <SignalNode :context="context" info="消防控制室（备用）" node-title="D4-2AN11-5" node-style="left: 69.65rem;top: 42.0rem;"></SignalNode>
        <SignalNode :context="context" info="消防电源箱（备用）" node-title="D4-2AN11-6" node-style="left: 71.6rem;top: 42.0rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN11-7" node-style="left: 73.65rem;top: 42.0rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN11-8" node-style="left: 75.65rem;top: 42.0rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN11-9" node-style="left: 77.65rem;top: 42.0rem;"></SignalNode>

        <SignalNode :context="context" info="商业" node-title="D4-2AN10-1" node-style="left: 81.54rem;top: 42rem;"></SignalNode>
        <SignalNode :context="context" info="商业" node-title="D4-2AN10-2" node-style="left: 83.58rem;top: 42.0rem;"></SignalNode>
        <SignalNode :context="context" info="避难走道用电" node-title="D4-2AN10-3" node-style="left: 85.66rem;top: 42.0rem;"></SignalNode>
        <SignalNode :context="context" info="室外活动预留配电箱" node-title="D4-2AN10-4" node-style="left: 87.73rem;top: 42.0rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN10-5" node-style="left: 89.78rem;top: 42.0rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN10-6" node-style="left: 91.85rem;top: 42.0rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN10-7" node-style="left: 93.95rem;top: 42.0rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN10-8" node-style="left: 96.01rem;top: 42.0rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN10-9" node-style="left: 98.06rem;top: 42.0rem;"></SignalNode>

        <SignalNode :context="context" info="商业" node-title="D4-2AN9-1" node-style="left: 100.14rem;top: 42.0rem;"></SignalNode>
        <SignalNode :context="context" info="商业" node-title="D4-2AN9-2" node-style="left: 102.23rem;top: 42.0rem;"></SignalNode>
        <SignalNode :context="context" info="商业" node-title="D4-2AN9-3" node-style="left: 104.29rem;top: 42.0rem;"></SignalNode>
        <SignalNode :context="context" info="商业" node-title="D4-2AN9-4" node-style="left: 106.32rem;top: 42.0rem;"></SignalNode>
        <SignalNode :context="context" info="商业" node-title="D4-2AN9-5" node-style="left: 108.39rem;top: 42.0rem;"></SignalNode>
        <SignalNode :context="context" info="UPS（主用）" node-title="D4-2AN9-6" node-style="left: 110.46rem;top: 42.0rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN9-7" node-style="left: 112.52rem;top: 42.0rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN9-8" node-style="left: 114.55rem;top: 42.0rem;"></SignalNode>


        <SignalNode :context="context" info="商业" node-title="D4-2AN8-1" node-style="left: 2.16rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="照明总箱2" node-title="D4-2AN8-2" node-style="left: 4.79rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="商业" node-title="D4-2AN8-3" node-style="left: 7.45rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="景观配电箱" node-title="D4-2AN8-4" node-style="left: 10.1rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="指挥中心电源箱（主用）" node-title="D4-2AN8-5" node-style="left: 12.7rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN8-6" node-style="left: 15.35rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN8-7" node-style="left: 18.0rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN8-8" node-style="left: 20.65rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN8-9" node-style="left: 23.25rem;top: 53.43rem;"></SignalNode>


        <SignalNode :context="context" info="球迷广场配电箱" node-title="D4-2AN7-1" node-style="left: 25.91rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="走道照明" node-title="D4-2AN7-2" node-style="left: 28.56rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="扶梯" node-title="D4-2AN7-3" node-style="left: 31.22rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="避难走道照明水泵（主用）" node-title="D4-2AN7-4" node-style="left: 33.85rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="电信（主用）" node-title="D4-2AN7-5" node-style="left: 36.5rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="UPS（备用）" node-title="D4-2AN7-6" node-style="left: 39.16rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN7-7" node-style="left: 41.783rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN7-8" node-style="left: 44.45rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN7-9" node-style="left: 47.08rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN7-10" node-style="left: 49.66rem;top: 53.43rem;"></SignalNode>

        <SignalNode :context="context" info="信息网络机房（备用）" node-title="D4-2AN6-1" node-style="left: 52.3rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="UPS（主用）" node-title="D4-2AN6-2" node-style="left: 54.97rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="普通风机" node-title="D4-2AN6-3" node-style="left: 57.595rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="商业" node-title="D4-2AN6-4" node-style="left: 60.233rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="站用电（备用）" node-title="D4-2AN6-5" node-style="left: 62.9rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="转播设备（备用）" node-title="D4-2AN6-6" node-style="left: 65.52rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN6-7" node-style="left: 68.16rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN6-8" node-style="left: 70.8rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN6-9" node-style="left: 73.47rem;top: 53.43rem;"></SignalNode>

        <SignalNode :context="context" info="端屏（主用）" node-title="D4-2AN5-1" node-style="left: 76.1rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="草坪补光系统" node-title="D4-2AN5-2" node-style="left: 78.73rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="安全照明（备用）" node-title="D4-2AN5-3" node-style="left: 81.4rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="展览馆" node-title="D4-2AN5-4" node-style="left: 84.0rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="环屏用电" node-title="D4-2AN5-5" node-style="left: 86.66rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN5-6" node-style="left: 89.297rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN5-7" node-style="left: 91.97rem;top: 53.43rem;"></SignalNode>
        <SignalNode :context="context" info="备用" node-title="D4-2AN5-8" node-style="left: 94.6rem;top: 53.43rem;"></SignalNode>

        <SignalNode :context="context" info="有源滤波装置" node-title="D4-2AN4" node-style="left: 98.4rem;top: 53.43rem;"></SignalNode>

        <SignalNode :context="context" info="动态自动无功补偿" node-title="D4-2AN3" node-style="left: 104.46rem;top: 53.43rem;"></SignalNode>

        <SignalNode :context="context" info="动态自动无功补偿" node-title="D4-2AN2" node-style="left: 108.91rem;top: 53.43rem;"></SignalNode>

        <SignalNode :context="context" info="4-#2变压器进线柜" node-title="D4-2AN1" node-style="left: 114.66rem;top: 53.34rem;"></SignalNode>

      </div>
    </div>
<!--    <div id="es4-animation-container"  style="width: 100vw;height: 100vh;position: absolute;left: 0; top: 0" v-if="!isSystemImgLoaded"></div>-->
  </div>
</template>

<script setup>

import {useSize} from "@/assets/js/size";
import SignalNode from "@/components/system/SignalNode";
import {ref} from "vue";
import {useRealTimeDataService} from "@/assets/js/realTimeDataService";
import {useSensorCompute} from "@/assets/js/sensorCompute";
import useUtils from "@/assets/js/utils";
const {height} = useSize();
let context = ref({})
const {alert} = useUtils();

function service(data){
  for (let key in data){
    context.value[key] = data[key];
    if (data[key]?.alert){
      alert.value['es4'] = true;
    }
  }
  context.value['alert'] = alert.value['es4'];
}
useRealTimeDataService(service, 4,{checkFR: true});
let sensorCompute = useSensorCompute(context);
</script>

<style scoped>
.diagram{
  position: relative;
  margin: 70px auto 0;
}
@media screen and (min-width: 3840px) {
  .diagram,.bg-diagram{
    width: 3840px;
  }
}
@media screen and (max-width: 3840px) {
  .diagram,.bg-diagram{
    width: 3840px;
  }
}

@media screen and (max-width: 3000px){
  .diagram,.bg-diagram{
    width: 3000px;
  }
}

@media screen and (max-width: 1920px){
  .diagram,.bg-diagram{
    width: 1920px;
  }
}

.diagram,.bg-diagram{
  width: 1920px;
}

.main-table{
  width: 9.5rem;
  height: 6.45rem;

  float:left;
  border:1px solid #666;
  text-align: center;
  color: white;
  line-height: 1.5625rem;
  font-size: 0.8125rem;
}
.main-table-row{
  width: 100%;
  height: 1.5625rem;
  line-height: 1.5625rem;
  font-size: 0.8125rem;
  border-bottom: 1px dashed grey;
  display: flex;
  flex-wrap: nowrap;
}
.main-table-row:last-child{
  border-bottom: none;
}
.main-table-cell{
  flex:0 50px;
}
.main-table-cell:nth-child(1){
  border-right: 1px dashed grey;
}
.main-table-cell:nth-child(2){
  flex:1 0px;
  font-weight: bold;
  font-size: 0.9375rem;
}
.main-table-cell:nth-child(3){
  border-left: 1px dashed grey;
  flex:0 30px;
}

.IA{
  color: #dede12
}
.IB{
  color:#0dd22d
}
.P{
  color: #00ceff;
}
.Q{
  color: #ec4cff;
}
.COS{
  color: #0d86ed ;
}
</style>